module.exports = __webpack_public_path__ + "img/goDown.cfc62d7e.png";